import EnvironmentConfig from '../interfaces/EnvironmentConfig'

const qaConfigs: EnvironmentConfig = {
    dashboardUrl: 'https://dashboard.casaqa.ajira.tech',
    onboardingDashboardUrl: 'https://onboarding.qa.casaretail.ai',
    ruleServerUrl: 'https://api.casaqa.ajira.tech',
    apiServerUrl: 'https://api.customerstudioqa.ajira.tech',
    redmineUrl: 'https://redmine.casaretail.ai',
    casaWebAppUrl: 'https://web.casaqa.ajira.tech',
    casaEcomUrl: 'https://ecom.casaqa.ajira.tech',
    casaBeatUrl: 'https://beat-api.casaqa.ajira.tech',
    turnedOffFeatures: [],
    ruleUiUrl: 'https://rules.casaqa.ajira.tech',
    nifiUrl: 'https://nifi.casaqa.ajira.tech/connector-test',
    ruleServiceToken: 'Soop1kY7.WOW,2mR%qK[dGIi Y|s6+zteZ5{]:)>-%1j7~%q_r:,+n`(--F2^#+@',
    keycloakConfig: {
        url: `https://auth.qa.casaretail.ai`,
        realm: `casa`,
        clientId: `casa_dashboard`,
    },
    financeOnboarding: {
        webhookUrl: 'https://n8n.casaqa.ajira.tech/webhook/finance-onboarding',
        submitToken: 'fb4yOjDdof5q5v9N4i8zKERMKtDKf0Jo',
        // reCAPTCHA v3 site key ("Casa Tenant Onboard Finance"). Public by design —
        // the secret half lives only in the n8n 'Web Config' node.
        recaptchaSiteKey: '6Lc17oEtAAAAAMnqd0yW_XEbjn0K1m5eF13sOF9z',
    },
}

export default qaConfigs
